import React from 'react';
import './Button.css';

export interface IButtonParams {
    /**
     * 'primary' (default) is the filled brand button. 'secondary' is the
     * outlined pill used for Cancel and other dismiss actions — it exists as a
     * variant here so the treatment lives in one place: the three Cancel
     * buttons in the portal each used to hand-roll it, which is how one of them
     * drifted to a solid black outline and label while the others stayed
     * brand-coloured with a hairline border.
     */
    variant?: 'primary' | 'secondary';
    text: string;
    width?: string;
    backgroundColor?: string;
    borderColor?: string;
    borderWidth?: string;
    borderStyle?: string;
    color?: string;
    onClick: () => void;
    disable?: boolean;
    testId?: string;
    fontSize?: string;
    height?: string;
    borderRadius?: string;
    fontWeight?: string;
}

const Button: React.FC<IButtonParams> = ({
    variant = 'primary',
    text,
    testId,
    width,
    backgroundColor,
    color,
    borderColor,
    borderWidth,
    borderStyle,
    fontSize,
    onClick,
    disable = false,
    height,
    fontWeight,
    borderRadius,
}) => {
    const isSecondary = variant === 'secondary';
    const defaultBackgroundColor = backgroundColor ? backgroundColor : (isSecondary ? 'none' : 'var(--primary-gradient)');
    const defaultColor = color ? color : (isSecondary ? 'var(--color-primary)' : 'white');
    const defaultBorderRadius = borderRadius ? borderRadius : '24px';
    const defaultHeight = height ? height : '48px';
    const defaultBorderColor = borderColor ? borderColor : (isSecondary ? 'var(--color-divider)' : 'transparent');
    const defaultBorderWidth = borderWidth ? borderWidth : '1px';
    const defaultBorderStyle = borderStyle ? borderStyle : 'solid';
    return (
        <>
            <button
                className="btn"
                type="button"
                onClick={() => onClick()}
                data-testid={testId}
                id={text}
                style={{
                    width: width,
                    background: defaultBackgroundColor,
                    color: defaultColor,
                    borderRadius: defaultBorderRadius,
                    borderColor: defaultBorderColor,
                    borderWidth: defaultBorderWidth,
                    borderStyle: defaultBorderStyle,
                    whiteSpace: 'nowrap',
                    zIndex: '1',
                    fontSize: fontSize ? fontSize : '15px',
                    minWidth: 'fit-content',
                    height: defaultHeight,
                    padding: '10px 30px',
                    fontWeight: fontWeight
                }}
                disabled={disable}
            >
                {text}
            </button>
        </>
    );
};
export default Button;